import React from 'react';

export default function PreviewForm(props) {
  return (
    <iframe src={`/preview.html?shop_id=${props.settings.id}&show=form`} title="W3Schools Free Online Web Tutorials" style={{width:'100%', height:'1500px'}}></iframe>
  )
}